import { Button } from '@fluentui/react-components';
import React from 'react';

const LoadingScreen: React.FC<{ message?: string }> = ({ message = 'Loading...' }) => {
    const isError = message.toLowerCase().includes('error') || message.toLowerCase().includes('failed');

    const handleRetry = () => {
        window.location.reload();
    };

    return (
        <>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                padding: '20px',
            }}>
                <div style={{
                    fontSize: '18px',
                    color: isError ? '#bc3b0a' : '#333',
                    marginBottom: '20px',
                    textAlign: 'center',
                    maxWidth: '500px',
                    lineHeight: '1.5',
                    whiteSpace: 'pre-wrap',
                }}>
                    {message}
                </div>
                {!isError && (
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #e0e0e0',
                        borderTop: '4px solid #0078d4',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                    }} />
                )}
                {isError && (
                    <Button
                        appearance="primary"
                        onClick={handleRetry}
                        style={{ marginTop: '20px' }}
                    >
                        Retry
                    </Button>
                )}
            </div>
        </>
    );
};

export default LoadingScreen;
